import ChromeLogo from '../assets/chrome-logo.js';
import FirefoxLogo from '../assets/firefox-logo.js';
import SafariLogo from '../assets/safari-logo.js';
import EdgeLogo from '../assets/edge-logo.js';
import BrowserLogo from '../assets/browser.js';
import Icon from 'components/Icons/Icon.js';
import _ from 'lodash';
import ToolTip from 'components/elements/atoms/ToolTip/ToolTip.js';
import moment from 'moment';
// import '../Users.scss';

export function getBrowserLogo(browserName) {
  if (browserName === 'chrome') {
    return ChromeLogo;
  } else if (browserName === 'safari') {
    return SafariLogo;
  } else if (browserName === 'firefox' || browserName === 'mozilla') {
    return FirefoxLogo;
  } else if (browserName === 'edge') {
    return EdgeLogo;
  }

  return BrowserLogo;
}

export function getBrowser(extensionName) {
  const lowerCaseExtension = extensionName.toLowerCase();

  if (lowerCaseExtension.includes('chrome')) {
    return 'chrome';
  } else if (lowerCaseExtension.includes('safari')) {
    return 'safari';
  } else if (
    lowerCaseExtension.includes('firefox') ||
    lowerCaseExtension.includes('mozilla')
  ) {
    return 'firefox';
  } else if (lowerCaseExtension.includes('edge')) {
    return 'edge';
  }

  return 'unknown browser';
}

export const showExtensions = (user, typeOfAction, inactiveTypeOfAction) => {
  const siteInfo = user.siteInfo;

  if (
    !siteInfo ||
    !Array.isArray(siteInfo.extensions) ||
    siteInfo.extensions.length === 0
  ) {
    return null;
  }

  const latestExtensions = siteInfo.extensions.sort((ext2, ext1) => {
    return moment(ext2.time).isAfter(ext1.time) ? -1 : 1;
  });

  const actionExtensions = latestExtensions.filter(
    (ext) =>
      ext &&
      ext[typeOfAction] &&
      ext[typeOfAction].time &&
      (!ext[typeOfAction][inactiveTypeOfAction] ||
        moment(ext[typeOfAction][inactiveTypeOfAction]).isBefore(
          ext[typeOfAction].time,
        )),
  );

  if (actionExtensions.length === 0) {
    return null;
  }

  return actionExtensions
    .filter((extension) => typeof extension === 'string' || extension.extension)
    .map((extension) => {
      if (typeof extension === 'string') {
        return extension;
      }

      return extension.extension;
    });
};

export const renderExtensions = (extensions) => {
  if (!Array.isArray(extensions) || extensions.length === 0) {
    return '-';
  }

  const browsers = extensions.map((extension) => getBrowser(extension));

  const browsersCount = browsers.reduce((prev, curr) => {
    prev[curr] = (prev[curr] || 0) + 1;
    return prev;
  }, {});

  return Object.keys(browsersCount).map((browser, index) => (
    <ToolTip
      key={index}
      toolTipText={`${_.startCase(browser)}${
        browsersCount[browser] === 1 ? '' : ` - ${browsersCount[browser]}`
      }`}
      toolTipPosition="bottom"
    >
      <div className="browser-container d-flex align-items-center">
        <Icon icon={getBrowserLogo(browser)} width={20} height={20} />
        {browsersCount[browser] !== 1 && (
          <span className="browser-count">{browsersCount[browser]}</span>
        )}
      </div>
    </ToolTip>
  ));
};
